<template>
  <v-container fluid>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="Student General Diary"
    >
      <v-card-actions>
        <router-link
          :to="{ name: 'studentGeneralDiary', params: { dateProp: date } }"
        >
          <v-btn
            absolute
            right
            top
            elevation="1"
            :class="{
              'mt-4': $vuetify.breakpoint.xs,
              'ml-4': $vuetify.breakpoint.smAndUp
            }"
            color="accent"
            type="submit"
          >
            <v-icon left>mdi-plus</v-icon>
            Add General Diary
          </v-btn>
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <form @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2"> From Date * </label>
              <custom-date-picker
                @input="clearAll()"
                v-model="fromDate"
                :minToDate="mindate"
                :maxToDate="currentDate"
              />
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2"> To Date * </label>
              <custom-date-picker
                v-model="toDate"
                :minToDate="mindate"
                :maxToDate="maxDate"
                @input="dateValidation()"
              />
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Select Class <span class="error--text">*</span></label
              >
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--Select--"
                name="classSelect"
                required
                v-model="selectedClassID"
                v-on:change="changeSections(), clearAll()"
                item-value="id"
                :items="classes"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Select Section <span class="error--text">*</span></label
              >

              <v-autocomplete
                class="my-0 py-1"
                placeholder="--Select--"
                v-on:change="clearAll()"
                name="sectionSelect"
                v-model="selectedSectionID"
                item-value="id"
                :items="classWiseSections"
                key="id"
                item-text="name"
                multiple
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <div class="inside">
                <v-btn color="success" elevation="1" @click="save()">
                  <v-icon left>mdi-text-box-check-outline </v-icon>
                  Apply
                </v-btn>
                <v-btn
                  class="ml-4"
                  height="35"
                  small
                  elevation="1"
                  type="reset"
                  @click="resetAll()"
                >
                  <v-icon left size="18"> mdi-restart</v-icon>
                  Reset
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-card>
      <v-card-component v-if="generalDiary.length > 0">
        <v-card-text
          class="pt-0 pr-1"
          :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }"
        >
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{
              'mr-0': $vuetify.breakpoint.xs,
              'mr-5': $vuetify.breakpoint.smAndUp
            }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width: 350px"
          />
        </v-card-text>
        <v-divider class="my-0" />
        <v-data-table
          :headers="headers"
          :items="generalDiary"
          :search.sync="search"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
        >
          <template v-slot:item.title="{ item }">
            {{ item.title || '---' }}
          </template>
          <template v-slot:item.date="{ item }">
            {{ new Date(item.date).toLocaleDateString() || '-' }}
          </template>

          <template v-slot:item.actions="{ item }">
            <router-link
              :to="{
                name: 'showStudentGeneralDiary',
                params: { generalDiaryID: item.id }
              }"
            >
              <v-btn class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon color="black" small> mdi-eye </v-icon>
              </v-btn>
            </router-link>
            <router-link
              :to="{
                name: 'editStudentGeneralDiary',
                params: { generalDiaryID: item.id }
              }"
            >
              <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center"
              >No Data Available</v-card-subtitle
            >
          </template>
        </v-data-table>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
// import _ from 'lodash'

// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
export default {
  name: 'viewStudentGeneralDiary',
  components: {
    MaterialCard,
    CustomDatePicker,
    VCardComponent
  },
  data () {
    const today = new Date()
    return {
      total: 0,
      date: moment().format('YYYY-MM-DD'),
      currentDate: new Date().toISOString().slice(0, 10),
      mindate: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 90
      )
        .toISOString()
        .slice(0, 10),
      maxDate: new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        today.getDate()
      )
        .toISOString()
        .slice(0, 10),
      fromDate: new Date().toISOString().slice(0, 10),
      toDate: new Date().toISOString().slice(0, 10),
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      inProgress: false,
      classSection: '',
      classSectionArray: [],
      selectedClassSectionArray: [],
      GeneralRemark: '',
      generalDiary: [],
      temp: '',
      type: '',
      search: '',
      academicYears: [],
      selectedClassID: '',
      selectedSectionID: [],
      name: '',
      title: '',
      classWiseSections: [],
      classes: [],
      sections: [],
      studentArray: [],
      hasClicked: false,
      loader: true,
      isLoading: false,
      isWrite: false,
      headers: [
        { text: 'Title', value: 'title', sortable: true },
        { text: 'Student Class', value: 'studentClass.name', sortable: true },
        {
          text: 'Student Section',
          value: 'studentSection.name',
          sortable: true
        },
        { text: 'Date', value: 'date', sortable: false },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },

  async created () {
    await this.onFranchiseeChange()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedClassID () {
      this.selectedSectionID = []
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID && this.academicYearID) {
          await this.getClassList()
        }
        this.clearAll()
        this.resetAll()
        this.inProgress = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`
        )
        if (data) {
          this.classes = data
          this.sections = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },

    changeSections: async function () {
      try {
        this.isLoading = true
        this.classWiseSections = []
        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        // _.forEach(this.selectedClassID, value => {
        //   let sectionarray = this.sections.find(obj => obj.id === value)
        //   console.log('sectionarray: ', sectionarray.studentSections)
        //   this.classWiseSections = this.classWiseSections.concat(sectionarray.studentSections)
        // })
        if (sectionarray) {
          this.classWiseSections = sectionarray.studentSections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    save: async function () {
      try {
        if (this.formValidation()) {
          const response = await http.get(
            `${constants.API_URL}/api/v1/communication/student-general-dairy`,
            {
              params: {
                academicYearID: this.academicYearID,
                franchiseeID: this.franchiseeID,
                date: this.date,
                fromDate: this.fromDate,
                toDate: this.toDate,
                classID: this.selectedClassID,
                sectionID: this.selectedSectionID.toString()
              }
            }
          )
          if (response.data.length === 0) {
            this.temp = 1
            this.$dialog.message.warning('No Data Found', {
              position: 'top',
              timeout: 4000
            })
          } else {
            this.generalDiary = response.data
            this.total = this.generalDiary.length
          }
          this.dateValidation()
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    formValidation () {
      if (this.franchiseeID.length === 0) {
        this.errMsg('Please select franchisee')
      } else if (this.fromDate === '') {
        this.errMsg('From Date cannot be empty!')
      } else if (this.toDate === '') {
        this.errMsg('To Date cannot be empty!')
      } else if (this.selectedClassID === '') {
        this.errMsg('Class cannot be empty!')
      } else if (this.selectedSectionID.toString() === '') {
        this.errMsg('Section cannot be empty!')
      } else {
        return true
      }
    },

    dateValidation () {
      if (this.fromDate === '') {
        this.errMsg('Select from date first')
        this.toDate = ''
      }
      if (this.fromDate > this.toDate) {
        this.errMsg('Please select valid date')
        this.toDate = ''
      }
    },
    clearAll: async function () {
      this.generalDiary = []
      this.temp = ''
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    resetAll: async function () {
      this.fromDate = this.currentDate
      this.toDate = this.currentDate
      this.selectedClassID = ''
      this.selectedSectionID = ''

      if (this.franchisee) {
        this.franchiseeID = this.franchisee.id
      } else {
        this.franchiseeID = ''
      }
      await this.onFranchiseeChange()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
